var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.3125C11.8553 10.3125 13.3594 8.80846 13.3594 6.95312C13.3594 5.09779 11.8553 3.59375 10 3.59375C8.14467 3.59375 6.64062 5.09779 6.64062 6.95312C6.64062 8.80846 8.14467 10.3125 10 10.3125ZM10 11.7188C7.36802 11.7188 5.23438 9.58511 5.23438 6.95312C5.23438 4.32114 7.36802 2.1875 10 2.1875C12.632 2.1875 14.7656 4.32114 14.7656 6.95312C14.7656 9.58511 12.632 11.7188 10 11.7188Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0156 17.8125C16.0156 14.4902 13.3223 11.7969 10 11.7969C6.67766 11.7969 3.98438 14.4902 3.98438 17.8125H2.57812C2.57812 13.7135 5.90101 10.3906 10 10.3906C14.099 10.3906 17.4219 13.7135 17.4219 17.8125H16.0156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.ade3abf1.svg";
export { ForwardRef as ReactComponent };